import ky from 'ky';
import { PodcastOnly } from '../models/podcasts';
import { apiUrl } from './api';

const cachedResults = {};
const abortController = new AbortController();

export async function fetchSearchResults(searchTerm): Promise<PodcastOnly[]> {
  // Use cached result if possible
  const cachedPodcasts = getCachedSearchResults(searchTerm);
  if (cachedPodcasts) return cachedPodcasts;

  const url = apiUrl('search-podcasts', { term: searchTerm });
  const results = (await ky.get(url, { signal: abortController.signal }).json()) as {
    podcasts: any[];
  };

  const { podcasts } = results;
  podcasts.forEach((podcast) => {
    delete podcast.debug;
  });
  cachedResults[searchTerm] = {
    expiration: Date.now() + 1000 * 60 * 60, // Cache for 1 hour
    podcasts,
  };
  return podcasts;
}

export function getCachedSearchResults(searchTerm): PodcastOnly[] | undefined {
  if (!cachedResults[searchTerm]) return;

  // Use cached result if possible
  const { expiration, podcasts } = cachedResults[searchTerm];
  if (expiration > Date.now()) {
    return podcasts;
  }
  // Clean up expired cache entry
  delete cachedResults[searchTerm];
}

export function abortSearch() {
  abortController.abort(); // Abort in-flight request
}

// For keeping track of prior input text
let lastInputText = '';
export function setLastInputText(value) {
  lastInputText = value;
}
export function getLastInputText() {
  return lastInputText;
}
